import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/forbidden-lands/forbidden-lands-logo.webp";
import sectionDivider from "../../../../src/assets/forbidden-lands/session16_17/bitter-reach-page-banner-session-16_17.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

import lilith from "../../../../src/assets/blade-runner/session03/lilith.webp";
import memoryLab from "../../../../src/assets/blade-runner/session03/memory-lab.webp";
import corgi from "../../../../src/assets/blade-runner/session03/corgi.webp";
import doc from "../../../../src/assets/blade-runner/session03/doc.webp";
import pawnShop from "../../../../src/assets/blade-runner/session03/pawn-shop.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession03 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "My Lunch With Corgi (Day 2, Shift 2)",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={corgi}
            caption="Corgi"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Corgi: black marketeer and information broker based out of Hawker's Circle."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The scent of grease wafts thick over the cluttered sprawl of Hawker's
          Circle; flickering neon signs prism off puddles of oil-slick rain.
          Marion pushes through the lunch crowd outside a chrome diner nestled
          under a collapsed billboard. His eyes scan the mass—then catch a glint
          in someone's glasses, a predatory shine from a bar patio on the roof
          across the street.
          <br />
          <br />
          The deep bark of an Ender rifle sounds out as Marion dives for cover.
          The crowd scatters in panic. The shooter bolts and Marion gives chase.
          Trying to maintain his high ground, the tactically armored shooter
          crashes through plate glass to the next rooftop. But it's a failed
          move and the assassin plunges to the alleyway with a shard of glass in
          their side. Marion performs a CUT OFF maneuver and tackles the killer,
          slamming the them into the pavement with a linebacker's grace.
          <br />
          <br />
          Held in Marion's grapple, the hit man's headset echoes garbled radio
          instructions: they manage to press a built-in shoulder button on their
          armor. With a hissing scream they and their gear begin to disintegrate
          in a phosphorescent flare. Marion rolls of quickly to avoid the burn.
          Within seconds, all that remains of the unidentified assailant is
          ashes running into the gutter from the thick rain pelting the sector.
          <br />
          <br />
          Marion brushes himself off and makes his way to the diner, where he
          finds his contact Corgi already seated. Inside the diner, Corgi
          doesn't flinch. He's perched at the counter like he owns the place, a
          plate of synth-eggs congealing before him.
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Hey Marion, what are you working on?"
          </font>{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Never mind"
          </font>
          , Marion grouses.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "I heard shots outside. Was that you?”
          </font>{" "}
          Corgi asks, barely glancing up, as if a hit squad outside was just
          more white noise.
          <br />
          <br />
          Marion, breathing hard, wipes glass dust from his jacket.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Look, that doesn't matter. This isn't a friendly visit. Me and my
            partner are in deep. That means you are too.”
          </font>
          <br />
          <br />
          Corgi's smile widens. The street-slick black marketeer—equal parts
          scavenger and dreamer—leans forward, voice low.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Then lucky for you, the Circle still owes me favors.”
          </font>
          <br />
          <br />
          He agrees to keep his ear to the concrete, eyes on the corners, and to
          report anything he learns about the Snake Pit shooting or this
          mysterious disintegrating killers business.
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Doc Badger",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={doc}
            caption="Doc Badger"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Doc Badger: wunderkind of the grey market tech scene."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Skinner arrives, his looming spinner settling like a metal cloud. The
          pawn shop sits near an abandoned factory with shattered frames where
          windows once were. Near the open door of the warehouse, a man in
          tactical armor with an Ender rifle, stumbles on a metal ladder and
          barks out a curse.
          <br />
          <br />
          Forewarned, Skinner zips as the hit man does a hip shop with his
          rifle. Skinner crounches behind his spinner and call Grinski, a local
          punk who works the street corners selling drugs. Grinski owes Skinner
          and agrees to tail the assassin and report back to Skinner. With three
          successes on the roll, we expect some good intel when it rolls in.
          <br />
          <br />
          Inside the shop, a skinny young man with dusty brown skin wearing a
          multi-pocket tech jacket and optiview work goggles greets Skinner
          with:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Wassup dad, you need something?”
          </font>{" "}
          Skinner shows Doc the photo from Leah's apartment.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “That's my logo on the back,”
          </font>{" "}
          Doc admits,
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            “but I don't talk about my clients; that's bad business. At Doc
            Badger's you don't just buy my work, you buy my discretion.”
          </font>{" "}
          Skinner slides over some chinyen and asks,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Does that do anything for you?"
          </font>
          . Doc grabs the chinyen and smiles,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Oh. Well chinyen is good business; it always changes my whole
            mood.”
          </font>
          <br />
          <br />
          Doc confirms the picture is a Stelline print Leah requested—a memory
          implant of her daughter. A family moment. He suggests Skinner follow
          up with the a memory lab. He taps the Sentinel article about Lilith
          Tyrell. Skinner seals the deal by promising future favors and
          channeling business Doc's way.
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Coco and Esper Wall (Day 2, Shift 3)",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={pawnShop}
            caption="Doc Badger's Pawn Shop"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="Doc Badger's Pawn Shop: a trove of black market tech and grey market curiosities, and junk."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Marion spends the next shift at LAPD. He visits Coco in the Crime Lab
          before visiting the Esper Wall. Coco, the lab tech, confirms the blood
          from the Snake Pit belongs to Sandor.
          <br />
          Marion decides to trust Coco and describes the way his would-be
          assassin disintegrated. He asks Coco to do some reseach but keep it
          off the radar for now.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Why do you think it was a replicant?"
          </font>
          , Coco asks, intrigued. Marion, rattled by the hitman's uncanny
          behavior, insists it wasn't human.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “It didn't seem scared. I assumed it was a Replicant.”
          </font>{" "}
          Coco muses.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Could have been some sort of fanatic too. Well, I've never heard of
            this tech. I'll look into it. How exciting!"
          </font>
          <br />
          Using the Esper Wall, Marion tracks Leah's movements—two successes on
          a pushed roll, but at the cost of empathy damage. He sees her getting
          into a MetroCab after the shooting, avoiding her LAPD spinner.
          Running? Hiding? Did she kill Sandor?
          <br />
          Shaken by what he sees—and what it means—Marion takes an empathy hit.
          He'll need a Baseline test next shift as his emotional state crumbles
          and he breaks.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Memory Lab",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={lilith}
            caption="Lilith Tyrell"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="When her uncle Eldon Tyrell was murdered by a Nexus-6, Lilith inherited his empire. She presided over the disasterous Nexus-8 model without a lifespan. The Replicant Riots of 2022 led to the Blackout and the collapse of the Tyrell Corporation. 
            Lilith herself was attacked and disappeared for nearly a decade. Now, Lilith Tyrell is trying to rebuild her career as a memory designer contracted to Wallace Corporation."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={memoryLab}
            caption="Memory Lab"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="Lilith Memory Lab, where dreams and traumatic memories are crafted for Nexus-9 obedience and safety."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Skinner identifies himself at the reception com at the front door of
          the Lilith Memory Lab. Terry, an eerie assistant with a Tyrell
          resemblance, takes a photo of Skinner's badge.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Any relation to the Tyrells? Maybe a distant relation?”
          </font>{" "}
          Skinner asks.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Oh, I'm not distantly related to anyone,”
          </font>{" "}
          Terry replies, smiling faintly, Nexus-9 origins implied by the words.
          <br />
          <br />
          Terry deposits Skinner at the edge of the cavernous and dark memory
          lab dome. Twenty yards away are two children drawing on the floor as a
          third stands watching. They giggle and then flicker and vanish.
          Holograms.
          <br />
          <br />
          Lilith Tyrell steps from the darkness, removing a strange headset.
          “The children were my latest work,” she explains.
          <br />
          <br />
          Skinner shows Dr. Tyrell the photo of Leah's Stelline print. Lilith
          confirms the memory depicted was her work crafting memories for Leah.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “An early piece. Happy off-world family. Basic stuff.”
          </font>{" "}
          She waves away concern over Leah's failed Baseline Tests.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “That's not uncommon in high-stress roles, like yours, being a Blade
            Runner.”
          </font>
          <br />
          <br />
          When Skinner reveals Leah may be unstable, Lilith offers a rare
          gesture: she replays the implanted memory.
          <br />
          <br />A hologram forms in mid-air:{" "}
          <em>
            a sunlit corridor. Red sands outside. A giggling child. An
            explosion. Screams. Masked gunmen. A daughter, still and lifeless.
            The scream of a horrified mother who has lost her child.
          </em>
          <br />
          <br />
          Skinner is shaken.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Why do you implant such a traumatic memory?"
          </font>{" "}
          Lilith defends the trauma:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Replicants are machines – no different from the blasters you carry.
            Infinitely more advanced of course, but machines none the less. The
            purpose of the memories I design is to control these machines in the
            most effective way possible – by imprinting them with a deep trauma.
            The memory of this trauma is conditioned to be triggered at any time
            the Replicant even considers the possibility of disobeying. This is
            a unique method for how I make the Nexus-9 Replicants fully
            obedient. It's simple, really. Morality has no role here. You
            wouldn't want that blaster in your holster to disobey you, would
            you?”
          </font>
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Who do you think the masked men in the memory are to Leah?"
          </font>{" "}
          Skinner asks. Lilith explains she left that part of the memory vague,
          so Leah could fill in the blanks herself.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "The memory is designed to be flexible, so the Replicant can adapt
            it to their own life experiences. Do you think she might have
            projected it to her recent life experiences?"
          </font>
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            Skinner presses: “That seems possible to me, especially given her
            recent behavior.Don't you think Leah would want revenge, against
            something, someone?”
          </font>
          <br />
          <br />
          Lilith hesitates.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “She might... but the memory design should counteract that.”
          </font>
          <br />
          <br />
          Skinner's final words:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “With all due respect, we think Leah may need help. She is be acting
            irregularly. She may be in danger and she may be dangerous. Miss
            Tyrell, we may be on the same side.”
          </font>
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">MEMORY LAB</h1>
              <small>Blade Runner Session 03</small>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            {/* <img src={sectionDivider} alt="section divider" /> */}
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner  "
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Holden chews out the gumshoes, Leah's apartment yields clues,
                  and our detectives take some downtime to rest before Day 2 of
                  the investigation.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Electric Dreams case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 02:{" "}
                  <a href="./blade-runner-session-02">The Tyger</a> -- Session
                  04: <a href="./blade-runner-session-04">Safehouse</a> ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession03;
